// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1nrcr","calendarButtons":"ClockData_calendarButtons__2uA1g"};